import styled from "styled-components/macro";
import { ButtonText } from "@loanbossinc/component-library";

export const StyledButtonText = styled(ButtonText)`
  & .MuiButton-label .material-icons {
    margin-right: 10px !important;
  }
`;

export const LineItemRowContainer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 12px 24px 12px 24px;
  box-sizing: border-box;
`;

export const LineItemRowButtons = styled.div`
  display: flex;
`;

export const LineItemDescription = styled.div`
  flex-grow: 1;
  padding-left: 8px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
`;
